import React from 'react'
import PropTypes from 'prop-types'
import { makeStyles } from '@material-ui/core/styles'
import Typography from 'components/Typography'
import { colors } from 'theme'

const useStyles = makeStyles(theme => ({
  item: {
    marginTop: 88,
    marginBottom: 88,
  },
  bio: {
    paddingTop: 48,
    paddingLeft: 85,
    lineHeight: 2.5,
    fontWeight: 300,
    position: 'relative',
  },
  bottomBorder: {
    position: 'relative',
    '&:after': {
      content: '""',
      backgroundColor: colors.primary,
      position: 'absolute',
      width: 120,
      height: 1,
      bottom: -8,
      left: 0,
    },
  },
}))

const MemberItem = (props) => {
  const { member, isDirector } = props
  const { name, position, boardPosition, bio } = member
  const classes = useStyles()
  const title = isDirector ? boardPosition : position

  return (
    <div className={classes.item}>
      <Typography variant="subtitle1" size={36} color="primary">{name}</Typography>
      {
        title ? <Typography className={classes.bottomBorder} variant="subtitle1" size={20}>{title}</Typography> : null
      }
      <Typography className={classes.bio}>
        {bio}
      </Typography>
    </div>
  )
}

MemberItem.propTypes = {}
MemberItem.defaultProps = {}

export default MemberItem
